import { ToggleMonitoringDrawer } from '@protector/entities/core/__legacy__/redux.actions';
import { COLOR_OPTIONS } from 'config/style';
import useSegmentTracking from 'core/utils/segment/useSegmentTracking';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getSystemFlags } from 'core/core.selectors';
import SvgMenuExpand from 'st-protector-icons/Minor/MenuExpand';
import NewSvgReport from 'st-protector-icons/Minor/NewSvgReport';

import { useCompanyOrOrganizationMatch, useWorkspaceMatch } from 'core/utils/hooks/usePathMatches';
import { FooterContainer, ReportFloatingButton, SideMenuFloatingButton } from './hall-footer-mobile-buttons.component.style';

interface HallFooterMobileButtonsProps {
  onMenuClick: () => void;
  isMenuOpen?: boolean;
}

const HallFooterMobileButtons = ({ onMenuClick, isMenuOpen }: HallFooterMobileButtonsProps) => {
  const systemFlags = useSelector(getSystemFlags);

  const matchWorkspace = useWorkspaceMatch();
  const matchCompany = useCompanyOrOrganizationMatch();

  const showReportButton = systemFlags?.P40_54871_enable_report_button_for_mobile && (matchWorkspace || matchCompany);
  const showSideMenuButtonFlag = systemFlags?.P40_54863_hide_sidebar_menu_in_mobile && !isMenuOpen;

  const dispatch = useDispatch();
  const segmentTracking = useSegmentTracking();

  const onHandleChangeDrawerVisibility = useCallback(() => {
    dispatch(ToggleMonitoringDrawer());
  }, [dispatch]);

  const handleOpenReports = useCallback(() => {
    segmentTracking.track('Export Report - Tapped to see Available Reports');
    onHandleChangeDrawerVisibility();
  }, [onHandleChangeDrawerVisibility, segmentTracking]);

  const handleOpenMenu = useCallback(() => {
    segmentTracking.track('Export Report - Tapped secondary floating action');
    onMenuClick();
  }, [onMenuClick, segmentTracking]);
  return (
    <FooterContainer>
      {showSideMenuButtonFlag && (
        <SideMenuFloatingButton type='primary' shape='circle' onClick={handleOpenMenu} data-testid='hall-footer-secondary'>
          <SvgMenuExpand width={18} height={18} color={COLOR_OPTIONS.NEUTRAL_60} />
        </SideMenuFloatingButton>
      )}
      {showReportButton && (
        <ReportFloatingButton type='primary' shape='circle' onClick={handleOpenReports} data-testid='hall-footer-button'>
          <NewSvgReport width={18} height={18} color={COLOR_OPTIONS.WHITE} />
        </ReportFloatingButton>
      )}
    </FooterContainer>
  );
};

export default HallFooterMobileButtons;
